import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from '../../Model/api-model';
import { environment } from '../../../environments/environment';
import { RestApiService } from 'src/app/Services/rest-api-service';
import {Message,MessageService} from 'primeng/api';
import { MySubscriptions, Subscription, ProductPlan, Plan, PlanApis, MyApprovals } from 'src/app/Model/product-model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-dash',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent {
  displayedColumns: string[] = ['appName', 'productName', 'nonProdStatus','apis'];
  @ViewChild('pagMain') paginator: MatPaginator;
  

  displayedColumnsAPIs: string[] = ['apis'];
  @ViewChild('pag',{static: true}) paginatorApis: MatPaginator;
  
  showNoSubData=false;
  showGrid=false;

   token:string;
   apis:Api[];
   cols: any[];
   subscriptionList:MySubscriptions;
   subscription:Subscription[];
   showSpiner;
   firstName;
   lastName;
   emailId;
   remarkTxt;
   dataSource ;
   dataSourceAPIs ;
   devStatus_qu;
   payerStatus_qu;
   brokerStatus_qu;

   providerStatus_qu;
   payerMsg_qu;
   devMsg_qu;
   brokerMsg_qu;
   providerMsg_qu;

   payerDisplay_qu=false;
   devDisplay_qu=false;
   brokerDisplay_qu=false;
   providerDisplay_qu=false;
   

   constructor(private router: Router,private restApi: RestApiService,private messageService:MessageService) {
   
    localStorage.setItem("is_cuurent_nav_aem","n");
   
    this.showSpiner=true;
   this.firstName= localStorage.getItem("firstName");
   this.lastName= localStorage.getItem("lastName");
   this.emailId= localStorage.getItem("email_ID");
   this.remarkTxt= "from .....Aetna's Developer Portal";

  this.devStatus_qu=localStorage.getItem("devStatus_qu");
  this.payerStatus_qu =localStorage.getItem("payerStatus_qu");

  this.brokerStatus_qu =localStorage.getItem("brokerStatus_qu");
  this.providerStatus_qu=localStorage.getItem("providerStatus_qu");




        if(this.devStatus_qu=='0'){
         
          this.devDisplay_qu=true;
    
          this.devMsg_qu="Your Third Party Developer Questionnaire is still pending for submission.";
       


        }
        if(this.payerStatus_qu=='0'){
          this.payerDisplay_qu=true;
          this.payerMsg_qu="Your Payer Questionnaire is still pending for submission.";
          
        }

       // console.log("outside "+this.brokerStatus_qu)
        if(this.brokerStatus_qu=='0'){
         // console.log("inside "+this.brokerStatus_qu)
          this.brokerDisplay_qu=true;
          this.brokerMsg_qu="Your Broker Questionnaire is still pending for submission.";
          
        }

        if(this.providerStatus_qu=='0'){
          this.providerDisplay_qu=true;
          this.providerMsg_qu="Your EHR Questionnaire is still pending for submission.";
          
        }

       
     


        if(this.devStatus_qu=='4' || this.devStatus_qu=='11'){
         
          this.devDisplay_qu=true;
    
          this.devMsg_qu="Additional information is required to approve your Third Party Developer Questionnaire.";
       


        }
        if(this.payerStatus_qu=='4' || this.payerStatus_qu=='11'){
          this.payerDisplay_qu=true;
          this.payerMsg_qu="Additional information is required to approve your Payer Questionnaire.";
          
        }


        if(this.brokerStatus_qu=='4' || this.brokerStatus_qu=='11'){
          this.brokerDisplay_qu=true;
          this.brokerMsg_qu="Additional information is required to approve your Broker Questionnaire.";
          
        }

        if(this.providerStatus_qu=='4' || this.providerStatus_qu=='11'){
         
          this.providerDisplay_qu=true;
    
          this.providerMsg_qu="Additional information is required to approve your EHR Questionnaire.";
     
        }

  // this.addnewOnboardingUser();
   }

   approvalStatus;

   approvalsVos:MyApprovals[];
   ngOnInit() {

    this.showNoSubData=true;
    this.showGrid=true; 
    this.mySubscription();    
    
    
     
   
}//end of nginit
  
      

          mySubscription(){
           // console.log("here we are")


           localStorage.setItem("my_new_vet_sd",'N');
           localStorage.setItem("my_new_vet_sp",'N');
           localStorage.setItem("my_new_vet_pd",'N');
           localStorage.setItem("my_new_vet_pp",'N');

             // new broker changes


             localStorage.setItem("my_new_vet_sb",'N');
             localStorage.setItem("my_new_vet_pb",'N');



              // new provider changes


              localStorage.setItem("my_new_vet_spd",'N');
              localStorage.setItem("my_new_vet_ppd",'N');


            return this.restApi.mySubscription().subscribe((data: {}) => {
            //   console.log(data);   
              this.subscriptionList=data as MySubscriptions;
              this.subscription=this.subscriptionList.subscription;
              this.approvalsVos=this.subscriptionList.approvalsVos;

            //  console.log(this.subscription); 
             for(const approval of this.approvalsVos){
                 this.showGrid=false;

                 console.log(" role "+approval.role); 
                
                 if(approval.role=='development'){
                  approval.roleText='Third Party Application';
                 }else if(approval.role=='payer'){
                  approval.roleText='Payer Application';
                 }
                 else if(approval.role=='provider'){
                  approval.roleText='EHR Application';
                 }
                 else{

                  approval.roleText='Broker Application';
                 }

                 console.log(" env "+approval.environment); 
                 console.log(" approval"+approval.approvalStatus); 
                if(approval.approvalStatus=='P' || approval.approvalStatus=='A')
                            if(approval.approvalStatus=='A'){
                              approval.cssname="qualified";
                              approval.statusText="Approved";
                            }
                            if(approval.approvalStatus=='P'){
                              approval.cssname="proposal";
                              approval.statusText="Pending";
                            }
                            if(approval.approvalStatus=='R'){
                              approval.cssname="unqualified";
                              approval.statusText="Rejected";
                            }

                            if(approval.environment=='sandbox' && approval.role=='development'){

                              localStorage.setItem("my_new_vet_sd",approval.approvalStatus);
                              
                            }
                            if(approval.environment=='sandbox' && approval.role=='payer'){
                                       
                              
                              localStorage.setItem("my_new_vet_sp",approval.approvalStatus);
                             
                            }
                            if(approval.environment=='production' && approval.role=='development'){
                            
                              localStorage.setItem("my_new_vet_pd",approval.approvalStatus);
                             
                            }
                            if(approval.environment=='production' && approval.role=='payer'){
                                     
                             
                                   localStorage.setItem("my_new_vet_pp",approval.approvalStatus);
                            }


                             // broker changes

                             if(approval.environment=='production' && approval.role=='broker'){
                                     
                             
                              localStorage.setItem("my_new_vet_pb",approval.approvalStatus);
                            }

                            if(approval.environment=='sandbox' && approval.role=='broker'){
                                     
                             
                              localStorage.setItem("my_new_vet_sb",approval.approvalStatus);
                            }


                            
                             // provider changes

                             if(approval.environment=='production' && approval.role=='provider'){
                                     
                             
                              localStorage.setItem("my_new_vet_ppd",approval.approvalStatus);
                            }

                            if(approval.environment=='sandbox' && approval.role=='provider'){
                                     
                             
                              localStorage.setItem("my_new_vet_spd",approval.approvalStatus);
                            }
             
              }//end of for
           
             
             
               if(this.showGrid){this.showNoSubData=false;}else{}


              this.showSpiner=false;
            },(error)=>{
              this.showSpiner=false;
            })
          }
    

      moveToAppCreation(myapproval:MyApprovals){


       console.log("path value : "+myapproval.role)

       console.log("path value : "+myapproval.environment)

       localStorage.setItem("direct_app","Y");
       localStorage.setItem("direct_app_role",myapproval.role);
       localStorage.setItem("direct_app_environment",myapproval.environment);

       this.router.navigate(['myapp']);
        
      }


          plans:ProductPlan;
          apisPlan:Plan[];
          apisView:PlanApis[];
          apisPlanCols:any[];
          apisViewEnable=false;
          selectedSub:Subscription;
          viewApisForSubscription(sub:Subscription){
            const productId=sub.productID;
            const plan=sub.plan;
          
            this.selectedSub=sub;
            localStorage.setItem("path",sub.environment);
            return this.restApi.getProductInfo(productId).subscribe((data: {}) => {
             //this.appList = data;
             this.plans=data as ProductPlan;
             this.apisPlan=this.plans.plans;
           //  console.log(this.plans); 
             for(const pln of  this.apisPlan){
                if(pln.name===plan){
                  this.apisView=pln.apis;
                
                  this.dataSourceAPIs = new MatTableDataSource<PlanApis>(this.apisView);
                  this.dataSourceAPIs.paginator = this.paginatorApis;
                  this.apisViewEnable=true;
                }
             }
          
           

              

           },(error)=>{
            this.showSpiner=false;
             // console.log(error);
           })
           
           }
 
           
         ngAfterViewChecked(){
            document.querySelectorAll('table')
            .forEach((input) => {
            //  console.log(input.getAttribute("role"));
               if(input.getAttribute("role")=="grid"){
                input.removeAttribute("role");
               }
             
            });
      
          }

          ngAfterViewInit() {
           
            window.scroll(0,0);
          }
      
}